import { useState, useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

interface Article {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  tags: string[];
  readTime: string;
  image: string;
}

// 所有文章數據
const allArticles: Article[] = [
  {
    id: 1,
    title: '搬家前30天完整準備清單，讓搬家不再手忙腳亂',
    excerpt: '搬家是一項複雜的工程，提前30天開始準備能讓整個過程更順利。本文為您整理完整的搬家準備時程表。',
    category: 'preparation',
    tags: ['搬家準備', '時程規劃', '清單'],
    readTime: '5分鐘',
    image: 'https://public.readdy.ai/ai/img_res/4740acee0f2b32e974513bd63158deff.jpg'
  },
  {
    id: 2,
    title: '專業打包技巧大公開：易碎品這樣包才安全',
    excerpt: '易碎品的打包是搬家中最需要技巧的部分。從餐具、電器到藝術品，不同物品需要不同的包裝方法。',
    category: 'packing',
    tags: ['打包技巧', '易碎品', '包裝材料'],
    readTime: '7分鐘',
    image: 'https://readdy.ai/api/search-image?query=Careful%20hands%20wrapping%20delicate%20dishes%20and%20glassware%20in%20bubble%20wrap%20professional%20packing%20materials%20clean%20white%20background&width=800&height=450&seq=tag002&orientation=landscape'
  },
  {
    id: 3,
    title: '搬家費用怎麼算？2024年最新計價方式大解析',
    excerpt: '搬家費用包含哪些項目？樓層費、距離費、特殊服務費如何計算？本文詳細解析搬家公司的收費標準。',
    category: 'cost',
    tags: ['搬家費用', '計價方式', '預算規劃'],
    readTime: '6分鐘',
    image: 'https://readdy.ai/api/search-image?query=Calculator%20with%20moving%20cost%20breakdown%20chart%20coins%20and%20bills%20professional%20document%20layout%20on%20clean%20desk&width=800&height=450&seq=tag003&orientation=landscape'
  },
  {
    id: 4,
    title: '冰箱搬運要注意什麼？家電搬家完全指南',
    excerpt: '家電搬運需要特別的專業技巧，尤其是冰箱、洗衣機等大型家電。',
    category: 'special-items',
    tags: ['家電搬運', '冰箱', '洗衣機', '大型物品'],
    readTime: '8分鐘',
    image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20carefully%20transporting%20a%20modern%20refrigerator%20with%20protective%20padding%20clean%20white%20background&width=800&height=450&seq=tag004&orientation=landscape'
  },
  {
    id: 5,
    title: '搬家當天流程安排，讓搬家效率提升50%',
    excerpt: '搬家當天的流程安排決定了整個搬家的效率。從早上的準備工作到最後的驗收。',
    category: 'preparation',
    tags: ['搬家流程', '效率提升', '時間管理', '搬家當天'],
    readTime: '5分鐘',
    image: 'https://readdy.ai/api/search-image?query=Moving%20day%20timeline%20with%20clock%20showing%20different%20phases%20organized%20boxes%20bright%20daylight&width=800&height=450&seq=tag005&orientation=landscape'
  },
  {
    id: 6,
    title: '搬家紙箱怎麼選？不同物品的包裝箱選擇指南',
    excerpt: '選對紙箱是成功搬家的第一步。書籍、衣物、廚具需要不同大小和強度的紙箱。',
    category: 'packing',
    tags: ['紙箱選擇', '包裝材料', '物品分類'],
    readTime: '4分鐘',
    image: 'https://readdy.ai/api/search-image?query=Various%20sizes%20of%20moving%20boxes%20stacked%20neatly%20different%20packing%20materials%20clean%20organized%20storage%20room&width=800&height=450&seq=tag006&orientation=landscape'
  },
  {
    id: 7,
    title: '鋼琴搬運專業指南：樂器搬家的注意事項',
    excerpt: '鋼琴等樂器的搬運需要專業的技術和設備。從立式鋼琴到平台鋼琴，不同類型有不同的搬運方式。',
    category: 'special-items',
    tags: ['鋼琴搬運', '樂器保護', '專業搬運', '貴重物品'],
    readTime: '6分鐘',
    image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20carefully%20transporting%20a%20grand%20piano%20with%20protective%20blankets%20clean%20white%20background&width=800&height=450&seq=tag007&orientation=landscape'
  },
  {
    id: 8,
    title: '搬家保險怎麼保？物品損壞理賠完整說明',
    excerpt: '搬家過程中物品損壞怎麼辦？搬家保險涵蓋哪些項目？理賠程序如何進行？',
    category: 'cost',
    tags: ['搬家保險', '理賠流程', '風險管理', '權益保護'],
    readTime: '5分鐘',
    image: 'https://readdy.ai/api/search-image?query=Insurance%20documents%20and%20protection%20shield%20symbol%20with%20moving%20boxes%20professional%20business%20setting&width=800&height=450&seq=tag008&orientation=landscape'
  },
  {
    id: 104,
    title: '搬家前要準備什麼？2026 完整準備清單與時程規劃',
    excerpt: '「搬家前要準備什麼？」這是每個即將搬家的人最常問的問題。本文完整解答搬家前的所有準備工作。',
    category: 'preparation',
    tags: ['搬家準備', '搬家清單', '搬家前準備', '搬家攻略', 'AI口語化問題'],
    readTime: '15分鐘',
    image: 'https://readdy.ai/api/search-image?query=Professional%20moving%20preparation%20checklist%20with%20calendar%20planner%20boxes%20packing%20supplies%20organized%20on%20clean%20white%20desk&width=800&height=450&seq=tag104&orientation=landscape'
  },
  {
    id: 105,
    title: '搬家公司怎麼選？2026 最完整比較指南與避雷攻略',
    excerpt: '「搬家公司怎麼選？」「哪家搬家公司比較好？」本文教您如何用 10 個關鍵指標選出最適合的搬家公司。',
    category: 'tips',
    tags: ['搬家公司推薦', '搬家公司選擇', '搬家公司比較', '搬家公司評價', 'AI口語化問題'],
    readTime: '18分鐘',
    image: 'https://readdy.ai/api/search-image?query=Professional%20moving%20company%20team%20with%20modern%20truck%20and%20equipment%20comparing%20services%20checklist&width=800&height=450&seq=tag105&orientation=landscape'
  },
  {
    id: 106,
    title: '搬家要多少錢？2026 最新費用行情與省錢攻略',
    excerpt: '「搬家要多少錢？」「搬家費用怎麼算？」本文完整解析 2026 年搬家費用行情。',
    category: 'cost',
    tags: ['搬家費用', '搬家價格', '搬家多少錢', '搬家報價', 'AI口語化問題', '預算規劃'],
    readTime: '16分鐘',
    image: 'https://readdy.ai/api/search-image?query=Moving%20cost%20calculation%20with%20calculator%20money%20bills%20coins%20and%20moving%20boxes%20on%20clean%20white%20desk&width=800&height=450&seq=tag106&orientation=landscape'
  },
  {
    id: 107,
    title: '搬家當天要注意什麼？完整流程與必做事項清單',
    excerpt: '「搬家當天要注意什麼？」搬家當天是整個搬家過程中最關鍵的一天。',
    category: 'preparation',
    tags: ['搬家當天', '搬家注意事項', '搬家流程', '搬家技巧', 'AI口語化問題'],
    readTime: '14分鐘',
    image: 'https://readdy.ai/api/search-image?query=Moving%20day%20scene%20with%20professional%20movers%20loading%20furniture%20into%20truck%20organized%20boxes%20labeled%20clearly&width=800&height=450&seq=tag107&orientation=landscape'
  },
  {
    id: 108,
    title: '搬家怎麼省錢？2026 最實用的 15 個省錢技巧大公開',
    excerpt: '「搬家怎麼省錢？」「搬家怎麼省比較快？」本文分享 15 個最實用的搬家省錢技巧。',
    category: 'cost',
    tags: ['搬家省錢', '搬家省錢技巧', '便宜搬家', '搬家預算', 'AI口語化問題'],
    readTime: '12分鐘',
    image: 'https://readdy.ai/api/search-image?query=Budget%20saving%20tips%20for%20moving%20with%20piggy%20bank%20coins%20calculator%20and%20moving%20boxes%20on%20clean%20white%20background&width=800&height=450&seq=tag108&orientation=landscape'
  },
  {
    id: 21,
    title: '2026 搬家東西壞掉怎麼賠？保險理賠完整指南與真實案例',
    excerpt: '搬家過程中物品損壞如何理賠？本文詳細說明理賠流程、範圍、金額與預防措施。',
    category: 'cost',
    tags: ['搬家保險', '理賠流程', '物品損壞', '權益保護', 'AI口語化問題'],
    readTime: '11分鐘',
    image: 'https://readdy.ai/api/search-image?query=Insurance%20claims%20process%20with%20damaged%20items%20and%20documentation%20professional%20setting&width=800&height=450&seq=tag021&orientation=landscape'
  },
  {
    id: 15,
    title: '搬家垃圾處理：環保搬家的實用建議',
    excerpt: '搬家過程會產生大量垃圾和不需要的物品。如何環保處理舊物、回收利用包裝材料。',
    category: 'transportation',
    tags: ['環保搬家', '垃圾處理', '資源回收', '廢棄物清運', 'AI口語化問題'],
    readTime: '4分鐘',
    image: 'https://readdy.ai/api/search-image?query=Recycling%20bins%20and%20eco-friendly%20packing%20materials%20organized%20waste%20sorting%20clean%20green%20environment&width=800&height=450&seq=tag015&orientation=landscape'
  },
  {
    id: 10,
    title: '辦公室搬遷規劃：企業搬家的專業建議',
    excerpt: '企業搬遷比家庭搬家更複雜，涉及設備、文件、員工等多方面考量。',
    category: 'preparation',
    tags: ['辦公室搬遷', '企業搬家', '業務連續性', '公司搬家'],
    readTime: '8分鐘',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20space%20with%20packed%20boxes%20and%20computer%20equipment%20professional%20business%20relocation&width=800&height=450&seq=tag010&orientation=landscape'
  },
  {
    id: 23,
    title: '寵物搬家安全指南：毛小孩搬家注意事項',
    excerpt: '寵物搬家需要特別的關愛和準備。如何減少寵物的焦慮？怎樣幫助牠們建立安全感？',
    category: 'special-items',
    tags: ['寵物搬家', '環境熟悉', '行為訓練', '毛小孩'],
    readTime: '7分鐘',
    image: 'https://readdy.ai/api/search-image?query=Happy%20pet%20in%20safe%20carrier%20with%20comfort%20items%20clean%20bright%20setting%20showing%20pet-friendly%20moving&width=800&height=450&seq=tag023&orientation=landscape'
  },
  {
    id: 30,
    title: '搬家風水指南：入宅吉日與注意事項',
    excerpt: '傳統習俗中，搬家入宅有許多講究。如何選擇良辰吉日？入宅當天有哪些儀式？',
    category: 'preparation',
    tags: ['搬家風水', '入宅吉日', '傳統習俗', '開運'],
    readTime: '6分鐘',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20calendar%20with%20auspicious%20dates%20cultural%20symbols%20and%20feng%20shui%20elements&width=800&height=450&seq=tag030&orientation=landscape'
  },
  {
    id: 32,
    title: '搬家斷捨離：搬家前的物品整理術',
    excerpt: '搬家是斷捨離的最佳時機。如何判斷物品該留該丟？二手物品如何處理？',
    category: 'preparation',
    tags: ['斷捨離', '物品整理', '極簡生活', '收納整理'],
    readTime: '6分鐘',
    image: 'https://readdy.ai/api/search-image?query=Organized%20decluttering%20process%20with%20sorted%20items%20donation%20boxes%20clean%20minimalist%20space&width=800&height=450&seq=tag032&orientation=landscape'
  },
  {
    id: 39,
    title: '搬家與孩子：如何幫助孩子適應新環境',
    excerpt: '搬家對孩子來說是重大改變。如何減少孩子的焦慮？怎樣幫助他們適應新學校和新朋友？',
    category: 'tips',
    tags: ['親子搬家', '兒童適應', '家庭搬遷', '心理調適'],
    readTime: '7分鐘',
    image: 'https://readdy.ai/api/search-image?query=Happy%20family%20with%20children%20in%20new%20home%20unpacking%20boxes%20together%20bright%20cheerful%20atmosphere&width=800&height=450&seq=tag039&orientation=landscape'
  },
  {
    id: 61,
    title: '夏季搬家攻略：高溫天氣的搬家注意事項',
    excerpt: '夏季是搬家旺季，但高溫天氣帶來許多挑戰。如何在炎熱天氣下安全搬家？',
    category: 'seasonal',
    tags: ['夏季搬家', '高溫應對', '防暑措施', '季節搬家'],
    readTime: '6分鐘',
    image: 'https://readdy.ai/api/search-image?query=Summer%20moving%20scene%20with%20movers%20working%20in%20hot%20weather%20cooling%20equipment%20bright%20sunny%20day&width=800&height=450&seq=tag061&orientation=landscape'
  },
  {
    id: 62,
    title: '冬季搬家指南：寒冷天氣的搬家準備',
    excerpt: '冬季搬家雖然是淡季，但寒冷天氣和可能的雨雪需要特別準備。',
    category: 'seasonal',
    tags: ['冬季搬家', '保暖措施', '雨雪應對', '季節搬家'],
    readTime: '6分鐘',
    image: 'https://readdy.ai/api/search-image?query=Winter%20moving%20preparation%20with%20warm%20clothing%20and%20weather%20protection%20equipment%20cold%20season%20relocation&width=800&height=450&seq=tag062&orientation=landscape'
  },
  {
    id: 63,
    title: '銀髮族搬家指南：長輩搬家的貼心建議',
    excerpt: '長輩搬家需要更多的關懷和協助。從體力考量到情感支持。',
    category: 'tips',
    tags: ['銀髮族搬家', '長輩照護', '無障礙搬家', '貼心服務'],
    readTime: '7分鐘',
    image: 'https://readdy.ai/api/search-image?query=Senior-friendly%20moving%20assistance%20with%20careful%20helpers%20and%20elderly%20person%20comfortable%20relocation&width=800&height=450&seq=tag063&orientation=landscape'
  },
  {
    id: 64,
    title: '單身搬家省錢術：一個人也能輕鬆搬家',
    excerpt: '單身族搬家物品較少，如何用最經濟的方式完成搬家？',
    category: 'cost',
    tags: ['單身搬家', '省錢技巧', '自助搬家', '小資搬家'],
    readTime: '5分鐘',
    image: 'https://readdy.ai/api/search-image?query=Single%20person%20moving%20with%20minimal%20belongings%20budget-friendly%20setup%20clean%20organized%20space&width=800&height=450&seq=tag064&orientation=landscape'
  },
  {
    id: 65,
    title: '新婚夫妻搬家指南：打造甜蜜新家',
    excerpt: '新婚搬家是人生重要時刻，如何規劃新家布置？兩個家庭的物品如何整合？',
    category: 'preparation',
    tags: ['新婚搬家', '新家布置', '物品整合', '甜蜜新居'],
    readTime: '6分鐘',
    image: 'https://readdy.ai/api/search-image?query=Newlywed%20couple%20planning%20new%20home%20together%20with%20moving%20boxes%20romantic%20happy%20atmosphere&width=800&height=450&seq=tag065&orientation=landscape'
  }
];

// 標籤分類配置
const tagCategories = [
  {
    name: 'AI口語化問題',
    icon: 'ri-voice-recognition-line',
    color: 'from-teal-500 to-cyan-600',
    tags: ['AI口語化問題', '搬家準備', '搬家費用', '搬家省錢', '搬家當天', '搬家公司選擇']
  },
  {
    name: '搬家準備',
    icon: 'ri-checkbox-circle-line',
    color: 'from-emerald-500 to-teal-600',
    tags: ['搬家準備', '搬家清單', '時程規劃', '搬家前準備', '搬家攻略', '搬家流程']
  },
  {
    name: '打包收納',
    icon: 'ri-box-3-line',
    color: 'from-amber-500 to-orange-600',
    tags: ['打包技巧', '包裝材料', '紙箱選擇', '物品分類', '收納整理', '斷捨離']
  },
  {
    name: '費用預算',
    icon: 'ri-money-dollar-circle-line',
    color: 'from-green-500 to-emerald-600',
    tags: ['搬家費用', '計價方式', '預算規劃', '搬家省錢', '省錢技巧', '搬家價格']
  },
  {
    name: '特殊物品',
    icon: 'ri-shield-check-line',
    color: 'from-cyan-500 to-teal-600',
    tags: ['家電搬運', '鋼琴搬運', '貴重物品', '易碎品', '寵物搬家', '大型物品']
  },
  {
    name: '保險理賠',
    icon: 'ri-shield-star-line',
    color: 'from-rose-500 to-pink-600',
    tags: ['搬家保險', '理賠流程', '風險管理', '權益保護', '物品損壞']
  },
  {
    name: '生活適應',
    icon: 'ri-home-heart-line',
    color: 'from-violet-500 to-purple-600',
    tags: ['親子搬家', '銀髮族搬家', '新婚搬家', '單身搬家', '心理調適']
  },
  {
    name: '季節搬家',
    icon: 'ri-sun-cloudy-line',
    color: 'from-yellow-500 to-amber-600',
    tags: ['夏季搬家', '冬季搬家', '季節搬家', '高溫應對', '雨雪應對']
  }
];

const TagsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedTag = searchParams.get('tag') || '';
  const [searchQuery, setSearchQuery] = useState('');

  // 統計所有標籤及其文章數量
  const tagStats = useMemo(() => {
    const stats: Record<string, number> = {};
    allArticles.forEach(article => {
      article.tags.forEach(tag => {
        stats[tag] = (stats[tag] || 0) + 1;
      });
    });
    return stats;
  }, []);

  // 獲取所有唯一標籤並排序
  const allTags = useMemo(() => {
    return Object.entries(tagStats)
      .sort((a, b) => b[1] - a[1])
      .map(([tag]) => tag);
  }, [tagStats]);

  // 篩選文章
  const filteredArticles = useMemo(() => {
    return allArticles.filter(article => {
      const matchesTag = !selectedTag || article.tags.includes(selectedTag);
      const matchesSearch = !searchQuery || 
        article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        article.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));
      return matchesTag && matchesSearch;
    });
  }, [selectedTag, searchQuery]);

  // 計算相關文章推薦（基於標籤相似度）
  const relatedArticles = useMemo(() => {
    if (!selectedTag) return [];
    
    // 獲取當前標籤的所有文章ID
    const currentArticleIds = new Set(filteredArticles.map(a => a.id));
    
    // 找出與當前標籤相關的其他標籤
    const relatedTags = new Set<string>();
    filteredArticles.forEach(article => {
      article.tags.forEach(tag => {
        if (tag !== selectedTag) {
          relatedTags.add(tag);
        }
      });
    });
    
    // 計算每篇文章的相關度分數
    const articleScores = allArticles
      .filter(article => !currentArticleIds.has(article.id))
      .map(article => {
        let score = 0;
        article.tags.forEach(tag => {
          if (relatedTags.has(tag)) {
            score += 2;
          }
        });
        // AI口語化問題文章加分
        if (article.tags.includes('AI口語化問題')) {
          score += 1;
        }
        return { article, score };
      })
      .filter(item => item.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 4)
      .map(item => item.article);
    
    return articleScores;
  }, [selectedTag, filteredArticles]);

  // 獲取相關標籤推薦
  const relatedTagsRecommend = useMemo(() => {
    if (!selectedTag) return [];
    
    const tagCooccurrence: Record<string, number> = {};
    
    // 計算標籤共現頻率
    allArticles.forEach(article => {
      if (article.tags.includes(selectedTag)) {
        article.tags.forEach(tag => {
          if (tag !== selectedTag) {
            tagCooccurrence[tag] = (tagCooccurrence[tag] || 0) + 1;
          }
        });
      }
    });
    
    return Object.entries(tagCooccurrence)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 6)
      .map(([tag]) => tag);
  }, [selectedTag]);

  // 熱門文章推薦（無選中標籤時顯示）
  const popularArticles = useMemo(() => {
    return allArticles
      .filter(article => article.tags.includes('AI口語化問題'))
      .slice(0, 4);
  }, []);

  // 搜尋標籤
  const filteredTags = useMemo(() => {
    if (!searchQuery) return allTags;
    return allTags.filter(tag => 
      tag.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [allTags, searchQuery]);

  const handleTagClick = (tag: string) => {
    if (selectedTag === tag) {
      setSearchParams({});
    } else {
      setSearchParams({ tag });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-teal-600 via-emerald-600 to-cyan-700 text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-price-tag-3-line text-xl"></i>
              <span className="font-medium">文章標籤系統</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              按標籤瀏覽文章
            </h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto mb-8">
              透過標籤快速找到您感興趣的搬家知識，{allTags.length} 個標籤、{allArticles.length}+ 篇專業文章
            </p>

            {/* 搜尋框 */}
            <div className="max-w-xl mx-auto">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜尋標籤或文章..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-6 py-4 pl-14 rounded-2xl text-gray-900 text-lg focus:outline-none focus:ring-4 focus:ring-white/30 shadow-xl"
                />
                <i className="ri-search-line absolute left-5 top-1/2 -translate-y-1/2 text-2xl text-gray-400"></i>
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery('')}
                    className="absolute right-5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                  >
                    <i className="ri-close-circle-fill text-2xl"></i>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* 麵包屑導航 */}
        <nav className="flex items-center text-sm text-gray-600 mb-8">
          <Link to="/" className="hover:text-teal-600 transition-colors">首頁</Link>
          <i className="ri-arrow-right-s-line mx-2"></i>
          <Link to="/knowledge" className="hover:text-teal-600 transition-colors">搬家知識</Link>
          <i className="ri-arrow-right-s-line mx-2"></i>
          <span className="text-gray-900 font-medium">標籤瀏覽</span>
          {selectedTag && (
            <>
              <i className="ri-arrow-right-s-line mx-2"></i>
              <span className="text-teal-600 font-medium">#{selectedTag}</span>
            </>
          )}
        </nav>

        {/* 標籤分類區塊 */}
        {!selectedTag && !searchQuery && (
          <div className="mb-16">
            <h2 className="text-2xl font-bold text-gray-900 mb-8 flex items-center gap-3">
              <i className="ri-folder-open-line text-teal-600"></i>
              標籤分類
            </h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {tagCategories.map((category, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all">
                  <div className={`w-12 h-12 bg-gradient-to-br ${category.color} rounded-xl flex items-center justify-center mb-4`}>
                    <i className={`${category.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{category.name}</h3>
                  <div className="flex flex-wrap gap-2">
                    {category.tags.slice(0, 4).map((tag, tagIndex) => (
                      <button
                        key={tagIndex}
                        onClick={() => handleTagClick(tag)}
                        className="px-3 py-1 bg-gray-100 hover:bg-teal-100 text-gray-700 hover:text-teal-700 text-sm rounded-full transition-colors cursor-pointer whitespace-nowrap"
                      >
                        #{tag}
                        {tagStats[tag] && (
                          <span className="ml-1 text-xs text-gray-500">({tagStats[tag]})</span>
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 熱門標籤雲 */}
        <div className="mb-12">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
              <i className="ri-fire-line text-orange-500"></i>
              {selectedTag ? `標籤：#${selectedTag}` : '熱門標籤'}
            </h2>
            {selectedTag && (
              <button
                onClick={() => setSearchParams({})}
                className="text-teal-600 hover:text-teal-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-close-line"></i>
                清除篩選
              </button>
            )}
          </div>
          
          <div className="bg-gradient-to-br from-gray-50 to-teal-50 rounded-2xl p-6 border border-gray-200">
            <div className="flex flex-wrap gap-3">
              {filteredTags.map((tag, index) => {
                const count = tagStats[tag];
                const isSelected = selectedTag === tag;
                const isPopular = count >= 3;
                
                return (
                  <button
                    key={index}
                    onClick={() => handleTagClick(tag)}
                    className={`px-4 py-2 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
                      isSelected
                        ? 'bg-gradient-to-r from-teal-600 to-emerald-600 text-white shadow-lg scale-105'
                        : isPopular
                        ? 'bg-white text-teal-700 border-2 border-teal-200 hover:border-teal-400 hover:bg-teal-50'
                        : 'bg-white text-gray-700 border border-gray-200 hover:border-teal-300 hover:bg-teal-50'
                    }`}
                  >
                    <span>#{tag}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs ${
                      isSelected ? 'bg-white/20' : 'bg-gray-100'
                    }`}>
                      {count}
                    </span>
                    {isPopular && !isSelected && (
                      <i className="ri-fire-fill text-orange-500 text-sm"></i>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* 相關標籤推薦 */}
        {selectedTag && relatedTagsRecommend.length > 0 && (
          <div className="mb-10 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-2xl p-6 border border-teal-100">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="ri-links-line text-teal-600"></i>
              相關標籤推薦
            </h3>
            <div className="flex flex-wrap gap-3">
              {relatedTagsRecommend.map((tag, index) => (
                <button
                  key={index}
                  onClick={() => handleTagClick(tag)}
                  className="px-4 py-2 bg-white text-teal-700 rounded-full font-medium border border-teal-200 hover:border-teal-400 hover:bg-teal-50 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 shadow-sm"
                >
                  <span>#{tag}</span>
                  <span className="px-2 py-0.5 bg-teal-100 rounded-full text-xs">
                    {tagStats[tag]}
                  </span>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* 文章列表 */}
        <div>
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
              <i className="ri-article-line text-teal-600"></i>
              {selectedTag ? `「${selectedTag}」相關文章` : '所有文章'}
              <span className="px-3 py-1 bg-teal-100 text-teal-700 rounded-full text-base font-semibold">
                {filteredArticles.length} 篇
              </span>
            </h2>
          </div>

          {filteredArticles.length > 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/knowledge/article/${article.id}`}
                  className="group cursor-pointer"
                >
                  <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 h-full flex flex-col border border-gray-100 hover:border-teal-200">
                    <div className="relative overflow-hidden h-48">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                      <div className="absolute bottom-3 right-3">
                        <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-gray-700 text-xs font-medium rounded-full flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {article.readTime}
                        </span>
                      </div>
                    </div>
                    
                    <div className="p-5 flex-1 flex flex-col">
                      <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors line-clamp-2 leading-tight">
                        {article.title}
                      </h3>
                      
                      <p className="text-gray-600 mb-4 line-clamp-2 text-sm flex-1">
                        {article.excerpt}
                      </p>
                      
                      <div className="flex flex-wrap gap-2 mb-4">
                        {article.tags.slice(0, 3).map((tag, index) => (
                          <span
                            key={index}
                            onClick={(e) => {
                              e.preventDefault();
                              handleTagClick(tag);
                            }}
                            className={`px-2 py-1 text-xs rounded-full cursor-pointer transition-colors ${
                              selectedTag === tag
                                ? 'bg-teal-600 text-white'
                                : 'bg-teal-50 text-teal-700 hover:bg-teal-100'
                            }`}
                          >
                            #{tag}
                          </span>
                        ))}
                        {article.tags.length > 3 && (
                          <span className="px-2 py-1 bg-gray-100 text-gray-500 text-xs rounded-full">
                            +{article.tags.length - 3}
                          </span>
                        )}
                      </div>
                      
                      <div className="flex items-center justify-end pt-3 border-t border-gray-100">
                        <span className="text-teal-600 font-semibold text-sm group-hover:gap-2 flex items-center gap-1 transition-all whitespace-nowrap">
                          閱讀全文 <i className="ri-arrow-right-line"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-16 bg-gray-50 rounded-2xl">
              <div className="w-24 h-24 mx-auto mb-6 bg-gray-200 rounded-full flex items-center justify-center">
                <i className="ri-search-line text-4xl text-gray-400"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">找不到相關文章</h3>
              <p className="text-gray-600 mb-6">試試其他標籤或關鍵字</p>
              <button
                onClick={() => {
                  setSearchParams({});
                  setSearchQuery('');
                }}
                className="px-6 py-3 bg-teal-600 text-white rounded-full font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看所有文章
              </button>
            </div>
          )}
        </div>

        {/* 相關文章推薦區塊 */}
        {selectedTag && relatedArticles.length > 0 && (
          <div className="mt-16 pt-12 border-t border-gray-200">
            <div className="flex items-center justify-between mb-8">
              <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
                  <i className="ri-lightbulb-line text-xl text-white"></i>
                </div>
                您可能也感興趣
              </h2>
              <Link
                to="/knowledge"
                className="text-teal-600 hover:text-teal-700 font-medium flex items-center gap-1"
              >
                探索更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {relatedArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/knowledge/article/${article.id}`}
                  className="group cursor-pointer"
                >
                  <div className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 h-full flex flex-col border border-gray-100 hover:border-amber-200">
                    <div className="relative overflow-hidden h-36">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                      <div className="absolute top-3 left-3">
                        <span className="px-2 py-1 bg-amber-500 text-white text-xs font-medium rounded-full">
                          推薦
                        </span>
                      </div>
                    </div>
                    
                    <div className="p-4 flex-1 flex flex-col">
                      <h3 className="text-sm font-bold text-gray-900 mb-2 group-hover:text-amber-600 transition-colors line-clamp-2 leading-tight">
                        {article.title}
                      </h3>
                      
                      <div className="flex flex-wrap gap-1 mt-auto">
                        {article.tags.slice(0, 2).map((tag, index) => (
                          <span
                            key={index}
                            className="px-2 py-0.5 bg-amber-50 text-amber-700 text-xs rounded-full"
                          >
                            #{tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* 熱門文章推薦（無選中標籤時顯示） */}
        {!selectedTag && !searchQuery && (
          <div className="mt-16 pt-12 border-t border-gray-200">
            <div className="flex items-center justify-between mb-8">
              <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-rose-500 to-pink-600 rounded-xl flex items-center justify-center">
                  <i className="ri-fire-line text-xl text-white"></i>
                </div>
                熱門口語化問題文章
              </h2>
              <Link
                to="/knowledge"
                className="text-teal-600 hover:text-teal-700 font-medium flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {popularArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/knowledge/article/${article.id}`}
                  className="group cursor-pointer"
                >
                  <div className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 h-full flex flex-col border border-gray-100 hover:border-rose-200">
                    <div className="relative overflow-hidden h-36">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                      <div className="absolute top-3 left-3">
                        <span className="px-2 py-1 bg-rose-500 text-white text-xs font-medium rounded-full flex items-center gap-1">
                          <i className="ri-fire-fill"></i> 熱門
                        </span>
                      </div>
                    </div>
                    
                    <div className="p-4 flex-1 flex flex-col">
                      <h3 className="text-sm font-bold text-gray-900 mb-2 group-hover:text-rose-600 transition-colors line-clamp-2 leading-tight">
                        {article.title}
                      </h3>
                      
                      <div className="flex items-center gap-2 text-xs text-gray-500 mt-auto">
                        <i className="ri-time-line"></i>
                        {article.readTime}
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* 快速問題導航 */}
            <div className="mt-10 bg-gradient-to-br from-gray-50 to-teal-50 rounded-2xl p-8 border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                <i className="ri-question-answer-line text-teal-600"></i>
                大家都在問
              </h3>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {[
                  { question: '搬家前要準備什麼？', id: 104 },
                  { question: '搬家公司怎麼選？', id: 105 },
                  { question: '搬家要多少錢？', id: 106 },
                  { question: '搬家當天要注意什麼？', id: 107 },
                  { question: '搬家怎麼省錢？', id: 108 },
                  { question: '搬家東西壞掉怎麼賠？', id: 21 }
                ].map((item, index) => (
                  <Link
                    key={index}
                    to={`/knowledge/article/${item.id}`}
                    className="flex items-center gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-teal-300 hover:shadow-md transition-all group"
                  >
                    <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-chat-3-line text-teal-600"></i>
                    </div>
                    <span className="text-gray-700 group-hover:text-teal-600 font-medium text-sm">
                      {item.question}
                    </span>
                    <i className="ri-arrow-right-s-line text-gray-400 group-hover:text-teal-600 ml-auto"></i>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* 返回知識中心 */}
        <div className="mt-12 text-center">
          <Link
            to="/knowledge"
            className="inline-flex items-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-full font-medium hover:bg-gray-200 transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            返回知識中心
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TagsPage;
